import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '& > * + *': {
        marginTop: '32px',
      },
    },
    content: {
      '$root &': {
        ...muiTheme.typography.body1,

        [muiTheme.breakpoints.up('md')]: {
          fontSize: '18px',
        },
      },
    },
    doubleSpacing: {
      '&:not(:first-child)': {
        marginTop: '58px',
      },

      '& + *': {
        marginTop: '58px',
      },
    },
  }),
  { name: 'BlogDetailContent' },
);

export default useStyles;
